<template>
  <div class="app-main-content voucher-maintenance">
    <div class="tabs-container">
      <div class="grid-view">
        <div class="main-content voucher-list">
          <search-item
            config-module="1900"
            :reset="true"
            :custom-sim-query-placeholder="$t('SystemMaintenance.QuickSearchAdTheme')"
            @click-more="value=>isAdvancedQuery=value"
            @simSearchItemCallBack="toSimpleQuery"
            @advSearchItemCallBack="toAdvancedQuery"
          >
            <div slot="operations" class="triggers" />
          </search-item>
          <div class="section grid-wrapper">
            <cargo-ag-grid
              :grid-params.sync="gridParams"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
              @gridReady="onReady"
            />
          </div>
          <div class="pagination-wrapper">
            <cargo-pagination
              :page-count="filter.pageCount"
              :total="filter.total"
              :page.sync="filter.pageNum"
              :limit.sync="filter.pageSize"
              @pagination="toQueryByPage"
            />
          </div>
        </div>
      </div>
    </div>
    <!--    点击用户列表-->
    <click-user-window :params="clickUserWindow.params" :visible="clickUserWindow.visible" @cancelVisible="cancelVisibleHandler" />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { getLoading } from '@/utils/utilBaseElement'
import { queryPromotionDataFunc } from '@/api/sysManage/advertisingConfig'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import clickUserWindow from '@/views/cargo/v0/SystemMaintenance/components/Ad/clickUserWindow'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'PromotionData',
  components: { searchItem, clickUserWindow },
  data() {
    return {
      gridParams: {},
      gridApi: null,
      isAdvancedQuery: true,
      clickUserWindow: {
        visible: false,
        params: {}
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false
      },
      filterJson: {
        advertisingTitle: '',
        page: 1,
        branchId: 0, // 分公司ID
        conditions: [], // 查询条件
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      selectedData: null,
      filter: {
        total: 0,
        pageNum: 1,
        pageCount: 0,
        pageSize: 20
      },
      columnDefs: [
        { headerName: this.$t('SystemMaintenance.AdCode'), field: 'advertisementNo', width: 120 },
        { headerName: this.$t('SystemMaintenance.AdThemename'), field: 'advertisingTitle', width: 120 },
        { headerName: this.$t('SystemMaintenance.AdLocation'), field: 'advertisingSpaceTitle', width: 120,
          valueFormatter: (params) => {
            const c = CommonState.getStateByCode(SystemConstants.AD_INDEX_LIST, params.value)
            if (c) {
              return c.chineseName
            }
            return ''
          }
        },
        { headerName: this.$t('SystemMaintenance.BelongsToPage'), field: 'page', width: 120,
          valueFormatter: (params) => {
            const c = CommonState.getStateByCode(SystemConstants.AD_PAGE_LIST, params.value)
            if (c) {
              return c.chineseName
            }
            return ''
          }
        },
        { headerName: this.$t('SystemMaintenance.BelongsToModule'), field: 'module', width: 120,
          valueFormatter: (params) => {
            const c = CommonState.getStateByCode(SystemConstants.AD_MODULE_LIST, params.value)
            if (c) {
              return c.chineseName
            }
            return ''
          }
        },
        { headerName: this.$t('SystemMaintenance.BelongingSystem'), field: 'systemSource', width: 120,
          valueFormatter: (params) => {
            const c = CommonState.getStateByCode(SystemConstants.AD_SYSTEM_LIST, params.value)
            if (c) {
              return c.chineseName
            }
            return ''
          }
        },
        { headerName: this.$t('SystemMaintenance.PageViews'), field: 'viewNumber', width: 120 },
        { headerName: this.$t('SystemMaintenance.Clicks'), field: 'clickNumber', width: 120 },
        { headerName: this.$t('SystemMaintenance.ClickRate'), field: 'clickThroughRate', width: 120,
          valueFormatter: (params) => {
            return params.value + '%'
          }
        },
        { headerName: this.$t('SystemMaintenance.NumberOfClickUsers'), field: 'clickUserNumber', width: 120,
          cellRenderer: params => {
            return '<a style="color: #0A0AFF; text-decoration: underline">' + params.value + '</a>'
          },
          onCellClicked: (params) => {
            this.showClickUserHandler(params.data)
          }
        },
        { headerName: this.$t('SystemMaintenance.PromotionPeriod'), field: 'timeStar', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.data.timeStar) + '~' + ColumnUtils.dateLabelFunc(params.data.timeEnd)
          }
        }
      ],
      rowData: []
    }
  },
  computed: {
  },
  mounted() {

  },
  methods: {
    onReady(params) {
      this.gridApi = params.api
    },
    showClickUserHandler(data) {
      if (data) {
        this.clickUserWindow.visible = true
        this.clickUserWindow.params = data
      }
    },
    // 分页查询
    toQueryByPage() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery(this.filterJson.advertisementTitle)
      }
    },
    toSimpleQuery(keyword) {
      this.filter.pageNum = 1
      this.filterJson.advertisementTitle = keyword.trim()
      this.filterJson.conditions = []
      this.toQuery()
    },
    toAdvancedQuery(data) {
      // 高级查询条件组装
      if (typeof data !== 'undefined') {
        this.filter.pageNum = 1
        this.filterJson.advertisementTitle = ''
      }
      this.toQuery(data)
    },
    toQuery(data) {
      if (typeof data !== 'undefined') {
        this.filterJson.conditions = data
      }
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.loading = getLoading()
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      queryPromotionDataFunc(this.filterJson).then(res => this.handleQueryData(res)).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      this.rowData = res.data.list
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.filter.pageCount = res.data.pages
      this.selectedData = null
      this.gridApi.clearFocusedCell()
      this.loading.close()
    },
    cancelVisibleHandler() {
      this.clickUserWindow.visible = false
    }
  }
}
</script>
